export default __webpack_public_path__ + "static/media/twister_responsive.0802e08e.png";